import { render, staticRenderFns } from "./CheckBoxModal.vue?vue&type=template&id=1728878a&scoped=true"
import script from "./CheckBoxModal.vue?vue&type=script&lang=ts"
export * from "./CheckBoxModal.vue?vue&type=script&lang=ts"
import style0 from "./CheckBoxModal.vue?vue&type=style&index=0&id=1728878a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728878a",
  null
  
)

export default component.exports